import PeopleListItem from './PeopleListItem';

export default PeopleListItem;
